import browserRequest from "superagent";

const { SOURCE_VERSION } = process.env;
const MISSING_VERSION = "???";

function checkIfLatestVersion() {
  if (!SOURCE_VERSION) {
    return Promise.resolve(true);
  }

  return browserRequest
    .get(
      `${window.location.protocol}//${window.location.host}/_version?v=${SOURCE_VERSION}`
    )
    .then(({ error, body }) => {
      if (error || !body || !body.version || body.version === MISSING_VERSION) {
        console.log(
          `[Version check] unable to check: ${(error && error.message) || body}`
        );
        return true; // assume we're up to date
      }

      console.log(
        `[Version check] latest=${body.version}, current=${SOURCE_VERSION}`
      );
      return body.version === SOURCE_VERSION;
    });
}

export default {
  checkIfLatestVersion
};



// WEBPACK FOOTER //
// ./src/app/utils/app.js